// extracted by mini-css-extract-plugin
export default {"footerbody":"footer_footerbody__dzaym","footer1":"footer_footer1__bvLbA","footer2":"footer_footer2__n5PyK"};